<script setup lang="ts">
import { marked } from "marked";
import { computed } from "vue";
import { tagWrapper } from "../utils/strings";

const props = defineProps<{ content: string }>();

const renderedMarkdown = computed(() => {
    const wrappedContent = tagWrapper(props.content);

    marked.setOptions({
        breaks: true,
        gfm: true,
    });

    const parsedContent = marked.parse(wrappedContent);
    const parser = new DOMParser();
    const doc = parser.parseFromString(parsedContent as string, "text/html");

    doc.querySelectorAll("a").forEach((link) => {
        link.setAttribute("target", "_blank");
        link.classList.add("hover:underline");
    });

    return doc.body.innerHTML;
});
</script>

<template>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="rich-content" v-html="renderedMarkdown"></div>
</template>
